import React, {useEffect, useMemo, useRef, useState} from "react";
import {Link} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {currencyFormat} from "../../../utils/masks";
import {getBank, getMovements} from "../../../services/Bank";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {IconButton} from "@material-ui/core";
import {MdDeleteForever} from "react-icons/md";
import {IoIosArrowBack, IoIosArrowForward} from "react-icons/io";
import {AiOutlineSearch} from "react-icons/ai";
import AlertDelete from "../../../components/Alert/AlertDelete";
import CustomButton from "../../../components/Form/Button";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableFooter from "@mui/material/TableFooter";
import messageTypes from "../../../constants/MessagesTypes";
import {actions} from "../../../redux/actions";
import {dateCurrent, dateFirstDayCurrent, firstDayMonth} from "../../../utils/date";
import {Form} from "@unform/web";
import InputDate from "../../../components/Form/InputDate";
import * as Yup from "yup";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";
import DivDiagonal from "../../../components/DivDiagonal";
import styled from "styled-components";
import {FaArrowDown, FaArrowUp, FaPercentage} from "react-icons/fa";
import {
    TradingWrapper,
    ContentArea,
    PageHeader as TradingPageHeader,
    HeaderActions,
    NewTradingButton,
    TradingCard,
    FilterSection,
    FilterTitle,
    StyledFilterFormWrapper,
    FilterRow,
    FilterField,
    FilterButtonWrap,
    StyledTableContainer,
    ActionButtons,
    PaginationInfo,
    PaginationButton,
    LoadingButton,
    TableWrapper,
} from "../../Trading/styles";
import {StrategyEmptyState} from "../../Strategy/styles";

const filterSearchBtnStyle = {
    background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
    border: 'none',
    color: '#ffffff',
    padding: '0 32px',
    borderRadius: '10px',
    fontWeight: 600,
    boxShadow: '0 4px 15px rgba(242, 146, 5, 0.3)',
    transition: 'all 0.3s ease',
    width: 'auto',
    minWidth: 'auto',
    height: '56px',
    display: 'flex',
    alignItems: 'center',
};

const RetireActionLink = styled(Link)`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 20px;
    border-radius: 10px;
    font-weight: 600;
    font-size: 14px;
    text-decoration: none !important;
    border: none;
    color: #ffffff !important;
    background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
    box-shadow: 0 4px 15px rgba(231, 76, 60, 0.4);
    transition: all 0.3s ease;

    &:hover {
        background: linear-gradient(135deg, #ff5e4d 0%, #d63031 100%);
        color: #ffffff !important;
        box-shadow: 0 6px 20px rgba(231, 76, 60, 0.5);
        transform: translateY(-2px);
    }

    @media (min-width: 768px) {
        padding: 12px 24px;
        font-size: 16px;
    }
`;

/** Igual /bank, /bank/view e /estrategias */
const MovementPageHeader = styled(TradingPageHeader)`
    z-index: 2;
    margin-bottom: 28px;

    @media (min-width: 768px) {
        margin-bottom: 36px;
    }
`;

const MovementCardWrap = styled.div`
    width: 100%;
    position: relative;
    z-index: 2;
    margin-top: 16px;

    @media (min-width: 576px) {
        margin-top: 20px;
    }

    @media (min-width: 992px) {
        margin-top: 24px;
    }
`;

const SummarySection = styled.div`
    padding: 4px 16px 8px;

    @media (min-width: 768px) {
        padding: 4px 32px 12px;
    }
`;

const SummaryHeading = styled.div`
    color: #f29205;
    font-size: 16px;
    font-weight: 700;
    margin: 0 0 16px 0;
    display: flex;
    align-items: center;
    gap: 10px;
    text-shadow: 0 0 10px rgba(242, 146, 5, 0.25);

    i {
        color: #ff6b35;
        font-size: 18px;
    }

    @media (min-width: 768px) {
        font-size: 17px;
        margin-bottom: 18px;

        i {
            font-size: 20px;
        }
    }
`;

const SummaryGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 14px;

    @media (min-width: 600px) {
        grid-template-columns: repeat(3, 1fr);
        gap: 16px;
    }
`;

const SummaryCard = styled.div`
    position: relative;
    border-radius: 16px;
    padding: 18px 16px 20px;
    background: linear-gradient(155deg, rgba(18, 22, 46, 0.98) 0%, rgba(26, 32, 58, 0.94) 100%);
    border: 1px solid ${(p) => p.$border};
    box-shadow:
        0 10px 28px rgba(0, 0, 0, 0.38),
        inset 0 1px 0 rgba(255, 255, 255, 0.05);
    transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 3px;
        background: linear-gradient(90deg, transparent, ${(p) => p.$line}, transparent);
        opacity: 0.95;
    }

    &:hover {
        transform: translateY(-4px);
        box-shadow:
            0 16px 40px rgba(0, 0, 0, 0.48),
            0 0 36px ${(p) => p.$glow};
        border-color: ${(p) => p.$borderHover};
    }
`;

const SummaryIconWrap = styled.div`
    width: 48px;
    height: 48px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;
    font-size: 21px;
    background: ${(p) => p.$bg};
    color: ${(p) => p.$fg};
    box-shadow: 0 4px 16px ${(p) => p.$shadow};
`;

const SummaryLabel = styled.div`
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #9aa3c4;
    line-height: 1.4;
    margin-bottom: 10px;
    min-height: 2.8em;
    display: flex;
    align-items: flex-end;
`;

const SummaryValue = styled.div`
    font-size: clamp(1.05rem, 2.8vw, 1.55rem);
    font-weight: 800;
    color: ${(p) => p.$c};
    line-height: 1.25;
    word-break: break-word;
`;

export default function Movement() {
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState([]);
    const [page, setPage] = useState(1);
    const [deleteMovement, setDeleteMovement] = useState(null);
    const [totalRate, setTotalRate] = useState(0);
    const [totalRetire, setTotalRetire] = useState(0);
    const [totalDeposit, setTotalDeposit] = useState(0);
    const {coinType} = useSelector((state) => state.BankReducer);
    const dispatch = useDispatch();
    const formRef = useRef(null);
    const { t } = useTranslation();

    const movementToDelete = useMemo(() => {
        if (!deleteMovement || !list?.data) {
            return null;
        }
        return list.data.find((r) => r.id === deleteMovement) || null;
    }, [deleteMovement, list]);

    const [filter, setFilter] = useState({
        startDate: dateFirstDayCurrent(),
        endDate: dateCurrent(),
    });

    async function handleSubmit(data) {
        try {

            formRef.current.setErrors({});
            const schema = Yup.object().shape({});

            await schema.validate(data, {
                abortEarly: false,
            });

            setFilter({
                startDate: data.startDate,
                endDate: data.endDate,
            });

        } catch (err) {
            if (err instanceof Yup.ValidationError) {
                const validationErrors = {};
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message;
                });
                formRef.current.setErrors(validationErrors);
                toast.warning(messageTypes.REQUIRED_FIELDS);
                return;
            }

            toast.error(messageTypes.ERROR);
        }
    }

    function updateResume(data) {
        let withdrawals = 0;
        let deposits = 0;
        let rate = 0;
        for (var index in data) {
            if (data[index].type === 'DEPOSIT') {
                deposits = deposits + parseFloat(data[index].value);
            } else {
                withdrawals = withdrawals + parseFloat(data[index].value);

                if (data[index].rate) {
                    rate = rate + parseFloat(data[index].rate);
                }
            }
        }

        setTotalRate(rate);
        setTotalRetire(withdrawals);
        setTotalDeposit(deposits);
    }

    useEffect(() => {
        setLoading(true);
        getMovements({
            page: page,
            per_page: 25,
            typeWinOrLoss: 'WIN',
            startDate: filter.startDate,
            endDate: filter.endDate,
        }).then((data) => {
            if (!data || data === '') {
                return;
            }

            setList(data.data);
            updateResume(data.data.data);
            setLoading(false);
        });

        return function cleanup() {
            setList([]);
        };
    }, [page, deleteMovement === true, filter]);

    useEffect(() => {
        getBank().then((data) => {
            dispatch(actions.updateBank(data));
        });
    }, [deleteMovement === true, dispatch]);

    return (
        <TradingWrapper>
            <DivDiagonal />
            <ContentArea>
                <MovementPageHeader>
                    <h1>
                        <i className="fas fa-exchange-alt" aria-hidden="true"/> {t('moviment_card_title')}
                    </h1>
                    <HeaderActions>
                        <RetireActionLink to="/bank/retire">
                            <i className="fas fa-minus"/> {t('moviment_retire')}
                        </RetireActionLink>
                        <NewTradingButton as={Link} to="/bank/deposit">
                            <i className="fas fa-plus"/> {t('moviment_deposit')}
                        </NewTradingButton>
                    </HeaderActions>
                </MovementPageHeader>

                <MovementCardWrap>
                <TradingCard>
                    <FilterSection>
                        <StyledFilterFormWrapper>
                            <Form ref={formRef} onSubmit={handleSubmit}>
                                <FilterTitle>
                                    <i className="fas fa-funnel-dollar"/> {t('filter')}
                                </FilterTitle>
                                <FilterRow>
                                    <FilterField>
                                        <InputDate
                                            name="startDate"
                                            label={t('filter_start_date')}
                                            value={firstDayMonth()}
                                            size={"small"}
                                        />
                                    </FilterField>
                                    <FilterField>
                                        <InputDate
                                            name="endDate"
                                            label={t('filter_end_date')}
                                            value={new Date()}
                                            size={"small"}
                                        />
                                    </FilterField>
                                    <FilterButtonWrap>
                                        <CustomButton
                                            className="btn font-weight-bold text-capitalize mobile-button"
                                            type="submit"
                                            startIcon={<AiOutlineSearch/>}
                                            style={filterSearchBtnStyle}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                                e.currentTarget.style.boxShadow = '0 6px 20px rgba(242, 146, 5, 0.4)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 4px 15px rgba(242, 146, 5, 0.3)';
                                            }}
                                        >
                                            {t('filter_btn_submmit')}
                                        </CustomButton>
                                    </FilterButtonWrap>
                                </FilterRow>
                            </Form>
                        </StyledFilterFormWrapper>
                    </FilterSection>

                    <SummarySection>
                        <SummaryHeading>
                            <i className="fas fa-chart-pie" aria-hidden="true"/> {t('moviment_summary_title')}
                        </SummaryHeading>
                        <SummaryGrid>
                            <SummaryCard
                                $border="rgba(255, 107, 107, 0.35)"
                                $borderHover="rgba(255, 107, 107, 0.6)"
                                $line="#ff6b6b"
                                $glow="rgba(255, 107, 107, 0.2)"
                            >
                                <SummaryIconWrap
                                    $bg="rgba(255, 107, 107, 0.14)"
                                    $fg="#ff8a8a"
                                    $shadow="rgba(255, 107, 107, 0.22)"
                                >
                                    <FaArrowDown aria-hidden="true"/>
                                </SummaryIconWrap>
                                <SummaryLabel>{t('moviment_total_retire')}</SummaryLabel>
                                <SummaryValue $c="#ff9a9a">
                                    {coinType} {currencyFormat(parseFloat(totalRetire))}
                                </SummaryValue>
                            </SummaryCard>
                            <SummaryCard
                                $border="rgba(91, 211, 124, 0.35)"
                                $borderHover="rgba(91, 211, 124, 0.58)"
                                $line="#5bd37c"
                                $glow="rgba(91, 211, 124, 0.2)"
                            >
                                <SummaryIconWrap
                                    $bg="rgba(91, 211, 124, 0.14)"
                                    $fg="#7ee8a0"
                                    $shadow="rgba(91, 211, 124, 0.22)"
                                >
                                    <FaArrowUp aria-hidden="true"/>
                                </SummaryIconWrap>
                                <SummaryLabel>{t('moviment_total_deposit')}</SummaryLabel>
                                <SummaryValue $c="#8aedab">
                                    {coinType} {currencyFormat(parseFloat(totalDeposit))}
                                </SummaryValue>
                            </SummaryCard>
                            <SummaryCard
                                $border="rgba(0, 212, 255, 0.28)"
                                $borderHover="rgba(0, 212, 255, 0.52)"
                                $line="#00d4ff"
                                $glow="rgba(0, 212, 255, 0.18)"
                            >
                                <SummaryIconWrap
                                    $bg="rgba(0, 212, 255, 0.14)"
                                    $fg="#5ce1ff"
                                    $shadow="rgba(0, 212, 255, 0.22)"
                                >
                                    <FaPercentage aria-hidden="true"/>
                                </SummaryIconWrap>
                                <SummaryLabel>{t('moviment_total_rate')}</SummaryLabel>
                                <SummaryValue $c="#7ae8ff">
                                    {coinType} {currencyFormat(parseFloat(totalRate))}
                                </SummaryValue>
                            </SummaryCard>
                        </SummaryGrid>
                    </SummarySection>

                    <TableWrapper>
                        {loading ? (
                            <LoadingButton
                                className="btn text-capitalize font-weight-bold"
                                loading={loading}
                                type="button"
                            >
                                {t('loading')}
                            </LoadingButton>
                        ) : (
                            <>
                                {list && list.data && list.data.length ? (
                                    <>
                                    <StyledTableContainer>
                                        <Table sx={{ minWidth: 650 }} aria-label="movements">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center">{t('moviment_table_col_date')}</TableCell>
                                                    <TableCell align="center">{t('moviment_table_col_type')}</TableCell>
                                                    <TableCell align="center">{t('moviment_table_col_value')}</TableCell>
                                                    <TableCell align="center">{t('retire_label_input_rate')}</TableCell>
                                                    <TableCell align="center">{t('moviment_table_col_options')}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {list.data.map((row) => (
                                                    <TableRow key={row.id}>
                                                        <TableCell align="center" component="th" scope="row">
                                                            {new Date(row.created.date).toLocaleDateString()}
                                                        </TableCell>
                                                        <TableCell align="center">{row.type === 'DEPOSIT' ? 'Depósito' : 'Retirada'}</TableCell>
                                                        <TableCell align="center">{coinType} {currencyFormat(row.value)}</TableCell>
                                                        <TableCell align="center">
                                                            {row.rate && row.rate > 0 && (
                                                                <>{coinType} {currencyFormat(row.rate)}</>
                                                            )}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <ActionButtons>
                                                                <IconButton
                                                                    aria-label="delete"
                                                                    onClick={() => {
                                                                        setDeleteMovement(row.id);
                                                                    }}
                                                                >
                                                                    <MdDeleteForever/>
                                                                </IconButton>
                                                            </ActionButtons>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                            <TableFooter>
                                                <TableRow>
                                                    <TableCell colSpan={5} style={{ border: 'none' }}>
                                                        <div style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            flexWrap: 'wrap',
                                                            gap: 16,
                                                        }}>
                                                            <PaginationInfo>
                                                                {t('table_pagination_text', {
                                                                    page,
                                                                    totalPage: list.total_page + 1,
                                                                })}
                                                            </PaginationInfo>
                                                            <div style={{ display: 'flex', gap: 8 }}>
                                                                <PaginationButton
                                                                    type="button"
                                                                    onClick={() => setPage(page - 1)}
                                                                    disabled={page <= 1}
                                                                >
                                                                    <IoIosArrowBack/> {t('table_pagination_back')}
                                                                </PaginationButton>
                                                                <PaginationButton
                                                                    type="button"
                                                                    onClick={() => setPage(page + 1)}
                                                                    disabled={!list.next_page}
                                                                >
                                                                    {t('table_pagination_next')} <IoIosArrowForward/>
                                                                </PaginationButton>
                                                            </div>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            </TableFooter>
                                        </Table>
                                    </StyledTableContainer>
                                        {movementToDelete && (
                                            <AlertDelete
                                                text={movementToDelete.type === 'DEPOSIT' ?
                                                    t('deposit_delete', {
                                                        value: `${coinType} ${currencyFormat(movementToDelete.value)}`,
                                                    }) :
                                                    t('retire_delete', {
                                                        value: `${coinType} ${currencyFormat(movementToDelete.value)}`,
                                                    })
                                                }
                                                setSuccessDelete={setDeleteMovement}
                                                urlDelete={`${process.env.REACT_APP_API_ENDPOINT}/api/bank/movement/delete/${movementToDelete.id}`}
                                            />
                                        )}
                                    </>
                                ) : (
                                    <StrategyEmptyState>
                                        <i className="fas fa-exchange-alt" aria-hidden="true"/>
                                        <p>{t('moviment_empty_title')}</p>
                                        <span>{t('moviment_empty_subtitle')}</span>
                                    </StrategyEmptyState>
                                )}
                            </>
                        )}
                    </TableWrapper>
                </TradingCard>
                </MovementCardWrap>
            </ContentArea>
        </TradingWrapper>
    );
}
